<template>
    <div>
        <div class="w_1200 clearfix2 box_mh20">
            <div class="fl black6_text box_pt8 site_th">
                <span class="home_icon icon_public box_mr8"></span>
                <span class="text_m">当前位置：<router-link tag="a" to="/">首页</router-link>
                    <span class="china">&gt;</span><router-link tag="a" :to="'/'+selectedNavEn" v-text="selectedNav"></router-link>
                    <span class="china">&gt;</span><span v-text="selectedNav"></span>详情
                </span>
            </div>
            <div class="fr" hidden>
                <Search/>
            </div>
        </div>
        <!--end一行-->

        <div class="clearfix2 box_mt20 w_1200 h_tab">
            <dl class="tab_nav d_tab_nav">
                <dd class="font_18 font_b">
                    <a href="javascript:void(0);" :class="{tab_light:selectedTab==='详细信息'}" @click="selectedTab='详细信息'" v-text="selectedNav === '竞价结果' ? '结果公告' : '详细信息'"></a>
                    <a href="javascript:void(0);" :class="{tab_light:selectedTab==='竞买信息'}" @click="selectedTab='竞买信息'" v-show="showJmxx" id="JMXX">竞买信息</a>
                    <a href="javascript:void(0);" :class="{tab_light:selectedTab==='结果公示'}" @click="selectedTab='结果公示'" v-show="showJggs">结果公示</a>
                </dd>
            </dl>
            <div class="tab_box">
                <div v-show="selectedTab==='详细信息'">
                    <div class="link_div box_c box_mh30 blue_link">
                        <a href="javascript:void(0);" class="item_a box_sizing cd-popup-trigger0">查看交易公告</a>
                        <a href="javascript:void(0);" class="item_a box_sizing cd-popup-trigger1" v-show="false">查看须知</a>
                        <a href="javascript:void(0);" class="item_a box_sizing cd-popup-trigger2">查看现场图</a>
                        <a href="javascript:void(0);" class="item_a box_sizing cd-popup-trigger3" v-show="false">查看视频</a>
                        <a href="javascript:void(0);" class="item_a box_sizing cd-popup-trigger4">查看挂牌文件</a>
                    </div>


                    <table class="list_table_y blue_link box_mt20" v-if="detail.zylxCode==='01'">
                        <tbody>
                        <tr v-if="selectedNav==='竞价结果'">
                            <td colspan="4" style="text-align: center;">
                                挂牌活动已经截止，宗地<span style="color: red;" v-text="detail.extData.sfpmcg ? '已成交' : '已流拍'"></span>
                            </td>
                        </tr>
                        <tr>
                            <th width="16%">宗地名称</th>
                            <td width="35%" v-text="detail.xmmc"></td>
                            <th width="16%">挂牌竞价开始时间</th>
                            <td v-text="detail.gpqssj"></td>
                        </tr>
                        <tr>
                            <th>宗地编号</th>
                            <td v-text="detail.zybh"></td>
                            <th>保证金缴纳截止时间</th>
                            <td v-text="detail.bzjdzjzsj"></td>
                        </tr>
                        <tr>
                            <th>交易类型</th>
                            <td v-text="detail.jylxText"></td>
                            <th>挂牌竞价截止时间</th>
                            <td v-text="detail.gpjzsj"></td>
                        </tr>
                        <tr>
                            <th>所属区域</th>
                            <td v-text="detail.qyText"></td>
                            <th>竞买申请截止时间</th>
                            <td v-text="detail.sgjzsj"></td>
                        </tr>
                        <tr>
                            <th>使用权面积</th>
                            <td><span v-text="detail.syqmj"></span> 平方米</td>
                            <th>地块亩数</th>
                            <td v-text="detail.dkms || '-'"></td>
                        </tr>
                        <tr>
                            <th>出让/转让年限(年)</th>
                            <td v-text="detail.crnx || '-'"></td>
                            <th>土地用途</th>
                            <td v-text="detail.extData.xxghyt || '-'"></td>
                        </tr>
                        <tr>
                            <th>容积率上限</th>
                            <td v-text="detail.extData.rjlsx || '-'"></td>
                            <th>容积率下限</th>
                            <td v-text="detail.extData.rjlxx || '-'"></td>
                        </tr>
                        <tr>
                            <th>建筑密度（%）</th>
                            <td v-text="detail.extData.jzmdsx || '-'"></td>
                            <th>绿化率（%）</th>
                            <td v-text="detail.extData.lhlsx || '-'"></td>
                        </tr>
                        <tr>
                            <th>竞买保证金</th>
                            <td><span v-text="detail.jmbzjwy"></span> <span v-text="detail.jgdwText"></span></td>
                            <th>起始价</th>
                            <td><span v-text="detail.qsjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr>
                            <th>成交时间</th>
                            <td :style="{color: detail.extData.sfpmcg ? 'red' : null}" v-text="detail.cjsj ? detail.cjsj : '-'"></td>
                            <th>加价幅度</th>
                            <td><span v-text="detail.zjfdwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr v-show="detail.extData.sfpmcg">
                            <th>竞得人</th>
                            <td style="color: red;" v-text="detail.jdr ? detail.jdr : '-'"></td>
                            <th>成交金额</th>
                            <td style="color: red;"><span v-text="detail.cjjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr>
                            <th>其他需要公告的事项</th>
                            <td colspan="3">
                                <div style="height: 100px;">
                                    温馨提示 1、凡首次参加网上挂牌活动竟买申请人需提前到代理点办理数字证书。 2、请有意参加竞买的申请人留足（转帐、汇款）时间将竞买保证金交纳到指定帐户，避免未能及时到达指定帐户而导致申请人未能取得竞买资格，竞买保证金及时到帐网上交易系统将自动确认其竞买资格。 3、竞买人在网上挂牌交易系统的任何操作过程中尽量不要在最后时刻完成操作，为避免因网络传输不畅造成损失，以防止网上挂牌交易无法及时接收到竞买申请、报价等情况发生，由此产生的风险由竞买人自己承担。请有意参加的竞买人应提前进行网上挂牌交易系统操作。
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>


                    <table class="list_table_y blue_link box_mt20" v-else-if="detail.zylxCode==='03'">
                        <tbody>
                        <tr v-if="selectedNav==='竞价结果'">
                            <td colspan="4" style="text-align: center;">
                                挂牌活动已经截止，矿业权<span style="color: red;" v-text="detail.extData.sfpmcg ? '已成交' : '已流拍'"></span>
                            </td>
                        </tr>
                        <tr>
                            <th width="16%">资源名称</th>
                            <td width="35%" v-text="detail.xmmc"></td>
                            <th width="16%">挂牌竞价开始时间</th>
                            <td v-text="detail.gpqssj"></td>
                        </tr>
                        <tr>
                            <th>资源编号</th>
                            <td v-text="detail.zybh"></td>
                            <th>保证金缴纳截止时间</th>
                            <td v-text="detail.bzjdzjzsj"></td>
                        </tr>
                        <tr>
                            <th>交易类型</th>
                            <td v-text="detail.jylxText"></td>
                            <th>挂牌竞价截止时间</th>
                            <td v-text="detail.gpjzsj"></td>
                        </tr>
                        <tr>
                            <th>所属区域</th>
                            <td v-text="detail.qyText"></td>
                            <th>竞买申请截止时间</th>
                            <td v-text="detail.sgjzsj"></td>
                        </tr>
                        <tr>
                            <th>矿权位置</th>
                            <td v-text="detail.kqwz"></td>
                            <th>资源储量</th>
                            <td v-text="detail.zycl"></td>
                        </tr>
                        <tr>
                            <th>矿区面积</th>
                            <td v-text="detail.kqmj + 'km²'"></td>
                            <th>矿种</th>
                            <td v-text="detail.kzmc"></td>
                        </tr>
                        <tr>
                            <th>开采年限</th>
                            <td v-text="detail.kcnxn"></td>
                            <th>开采方式</th>
                            <td v-text="detail.kcfs ? detail.kcfs : '-'"></td>
                        </tr>
                        <tr>
                            <th>竞买保证金</th>
                            <td><span v-text="detail.jmbzjwy"></span> <span v-text="detail.jgdwText"></span></td>
                            <th>起始价</th>
                            <td><span v-text="detail.qsjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr>
                            <th>成交时间</th>
                            <td :style="{color: detail.extData.sfpmcg ? 'red' : null}" v-text="detail.cjsj ? detail.cjsj : '-'"></td>
                            <th>增价幅度</th>
                            <td><span v-text="detail.zjfdwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr v-show="detail.extData.sfpmcg">
                            <th>竞得人</th>
                            <td style="color: red;" v-text="detail.jdr ? detail.jdr : '-'"></td>
                            <th>成交金额</th>
                            <td style="color: red;"><span v-text="detail.cjjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr>
                            <th>其他需要公告的事项</th>
                            <td colspan="3">
                                <div style="height: 100px;">
                                    温馨提示 1、凡首次参加网上挂牌活动竟买申请人需提前到代理点办理数字证书。 2、请有意参加竞买的申请人留足（转帐、汇款）时间将竞买保证金交纳到指定帐户，避免未能及时到达指定帐户而导致申请人未能取得竞买资格，竞买保证金及时到帐网上交易系统将自动确认其竞买资格。 3、竞买人在网上挂牌交易系统的任何操作过程中尽量不要在最后时刻完成操作，为避免因网络传输不畅造成损失，以防止网上挂牌交易无法及时接收到竞买申请、报价等情况发生，由此产生的风险由竞买人自己承担。请有意参加的竞买人应提前进行网上挂牌交易系统操作。
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <table class="list_table_y blue_link box_mt20" v-if="detail.zylxCode==='04'">
                        <tbody>
                        <tr v-if="selectedNav==='竞价结果'">
                            <td colspan="4" style="text-align: center;">
                                挂牌活动已经截止，标的<span style="color: red;" v-text="detail.extData.sfpmcg ? '已成交' : '已流拍'"></span>
                            </td>
                        </tr>
                        <tr>
                            <th width="16%">标的名称</th>
                            <td width="35%" v-text="detail.xmmc"></td>
                            <th width="16%">挂牌竞价开始时间</th>
                            <td v-text="detail.gpqssj"></td>
                        </tr>
                        <tr>
                            <th>标的编号</th>
                            <td v-text="detail.zybh"></td>
                            <th>保证金缴纳截止时间</th>
                            <td v-text="detail.bzjdzjzsj"></td>
                        </tr>
                        <tr>
                            <th>交易类型</th>
                            <td v-text="detail.jylxText"></td>
                            <th>挂牌竞价截止时间</th>
                            <td v-text="detail.gpjzsj"></td>
                        </tr>
                        <tr>
                            <th>所属区域</th>
                            <td v-text="detail.qyText"></td>
                            <th>竞买申请截止时间</th>
                            <td v-text="detail.sgjzsj"></td>
                        </tr>
                        <tr>
                            <th>使用权面积</th>
                            <td><span v-text="detail.syqmj"></span> 平方米</td>
                            <th>资源位置</th>
                            <td v-text="detail.extData.zywz || '-'"></td>
                        </tr>
                        <tr>
                            <th>竞买保证金</th>
                            <td><span v-text="detail.jmbzjwy"></span> <span v-text="detail.jgdwText"></span></td>
                            <th>起始价</th>
                            <td><span v-text="detail.qsjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr>
                            <th>成交时间</th>
                            <td :style="{color: detail.extData.sfpmcg ? 'red' : null}" v-text="detail.cjsj ? detail.cjsj : '-'"></td>
                            <th>增减幅度</th>
                            <td><span v-text="detail.zjfdwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr v-show="detail.extData.sfpmcg">
                            <th>竞得人</th>
                            <td style="color: red;" v-text="detail.jdr ? detail.jdr : '-'"></td>
                            <th>成交金额</th>
                            <td style="color: red;"><span v-text="detail.cjjwy"></span> <span v-text="detail.jgdwText"></span></td>
                        </tr>
                        <tr>
                            <th>其他需要公告的事项</th>
                            <td colspan="3">
                                <div style="height: 100px;">
                                    温馨提示 1、凡首次参加网上挂牌活动竟买申请人需提前到代理点办理数字证书。 2、请有意参加竞买的申请人留足（转帐、汇款）时间将竞买保证金交纳到指定帐户，避免未能及时到达指定帐户而导致申请人未能取得竞买资格，竞买保证金及时到帐网上交易系统将自动确认其竞买资格。 3、竞买人在网上挂牌交易系统的任何操作过程中尽量不要在最后时刻完成操作，为避免因网络传输不畅造成损失，以防止网上挂牌交易无法及时接收到竞买申请、报价等情况发生，由此产生的风险由竞买人自己承担。请有意参加的竞买人应提前进行网上挂牌交易系统操作。
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </div>
                <!--end详细信息-->
                <div v-if="isShowJmxx">
                    <Jmxx v-if="jjsType==='1'" :detail="detail"/>
                    <Jmxx2 v-else-if="jjsType==='2'" :detail="detail"/>
                </div>
                <div v-else></div>
                <!--end竞买信息-->
            </div>
            <!--end标签内容-->
        </div>
        <!--end一行-->

        <!--star_弹框 -->
        <div class="cd-popup">
            <!--is-visible去掉这个样式他就隐藏了,点击 href="javascript:;" class="cd-popup-trigger1"-->
            <div class="cd-popup-container clearfix2">
                <a href="#0" class="cd-popup-close transition_a f_close_btn"></a>
                <!--star内容-->
                <h4 class="blue_bj box_pw20 white_text font_16 f_code_th">查看交易公告</h4>
                <div class="box_mw20 box_pt20">
                    <div class="box_c box_line_d box_pd20">
                        <h3 class="font_22" v-text="cr_title"></h3>
                    </div>
                    <!--end标题-->

                    <div class="h_320 scroll_box box_mt20 d_wen box_mw20 font_16" style="height: 550px;">
                        <div class="box_pr30" v-if="detail.ggnr!==null">
                            <div class="detail_content" v-html="detail.ggnr"></div>
                            <div class="detail_content" v-if="detail.zylxCode==='01'" hidden>
                                <table style="margin-bottom: 50px;">
                                    <tbody>
                                    <tr>
                                        <td>委托方：</td>
                                        <td v-text="detail.wtf"></td>
                                        <td>区域：</td>
                                        <td v-text="detail.qyText"></td>
                                    </tr>
                                    <tr>
                                        <td>联系电话：</td>
                                        <td v-text="detail.extData.crrlxdh"></td>
                                        <td>应急电话：</td>
                                        <td v-text="detail.extData.yjlxdh"></td>
                                    </tr>
                                    <tr>
                                        <td>联系人：</td>
                                        <td v-text="detail.extData.crrlxr"></td>
                                        <td>联系地址：</td>
                                        <td v-text="detail.extData.crrlxdz"></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="no-data" style="display: none;" v-else>该栏目暂无数据</div>
                    </div>
                    <!--end内容-->


                </div>
                <!--end内容-->
            </div>
        </div>
        <!--end查看公告-->

        <div class="cd-popup1">
            <!--is-visible1去掉这个样式他就隐藏了,点击 href="javascript:;" class="cd-popup-trigger1"-->
            <div class="cd-popup-container1 clearfix2">
                <a href="#0" class="cd-popup-close transition_a f_close_btn"></a>
                <!--star内容-->
                <h4 class="blue_bj box_pw20 white_text font_16 f_code_th">查看须知</h4>

                <div class="box_mw20 box_pt20">
                    <div class="box_c box_line_d box_pd20">
                        <h2 class="font_b font_24" v-text="cr_title"></h2>
                        <h3 class="font_22" v-text="xzbt"></h3>
                    </div>
                    <!--end标题-->

                    <div class="h_320 scroll_box box_mt20 d_wen box_mw20 font_16" style="height: 550px;">
                        <div class="box_pr30 detail_content" v-html="detail.xznr" v-if="detail.xznr!==null"></div>
                        <div class="no-data" style="display: none;" v-else>该栏目暂无数据</div>
                    </div>
                    <!--end内容-->


                </div>
                <!--end内容-->
            </div>
        </div>
        <!--end查看须知-->

        <div class="cd-popup2">
            <!--is-visible2去掉这个样式他就隐藏了,点击 href="javascript:;" class="cd-popup-trigger2"-->
            <div class="cd-popup-container2 clearfix2">
                <a href="#0" class="cd-popup-close transition_a f_close_btn"></a>
                <!--star内容-->
                <h4 class="blue_bj box_pw20 white_text font_16 f_code_th">查看现场图</h4>

                <div class="box_c box_pt60 box_md40" v-if="fj.pic !== undefined && fj.pic !== null && fj.pic.length<=0" style="height: 750px;">
                    <img src="../assets/images/icon/null_box.png" alt="暂无数据">
                    <h4 class="font_16 black6_text box_mt20">暂无数据</h4>
                </div>
                <!--end暂无数据-->
                <div class="box_c box_pt20" style="height: 750px;" v-else>
                    <Attachment :fj="fj.pic"/>
                </div>
                <!--end内容-->
            </div>
        </div>
        <!--end查看现场图-->

        <div class="cd-popup3">
            <!--is-visible3去掉这个样式他就隐藏了,点击 href="javascript:;" class="cd-popup-trigger3"-->
            <div class="cd-popup-container3 clearfix2">
                <a href="#0" class="cd-popup-close transition_a f_close_btn"></a>
                <!--star内容-->
                <h4 class="blue_bj box_pw20 white_text font_16 f_code_th">查看视频</h4>

                <div class="box_c box_pt60 box_md40" v-if="fj.video !== undefined && fj.video !== null && fj.video.length<=0" style="height: 750px;">
                    <img src="../assets/images/icon/null_box.png" alt="暂无数据">
                    <h4 class="font_16 black6_text box_mt20">暂无数据</h4>
                </div>
                <!--end暂无数据-->
                <div class="d_video_div box_mt20" style="height: 750px;" v-else>
                    <video :src="fj.video[0].url" controls preload="none"></video>
                </div>
                <!--end内容-->
            </div>
        </div>
        <!--end查看视频-->

        <div class="cd-popup4">
            <!--is-visible4去掉这个样式他就隐藏了,点击 href="javascript:;" class="cd-popup-trigger4"-->
            <div class="cd-popup-container4 clearfix2">
                <a href="#0" class="cd-popup-close transition_a f_close_btn"></a>
                <!--star内容-->
                <h4 class="blue_bj box_pw20 white_text font_16 f_code_th">查看挂牌文件</h4>
                <div class="box_mt20 box_mw20 scroll_box h_400">
                    <table class="list_table box_c blue_link">
                        <thead>
                        <tr>
                            <th width="50px">序号</th>
                            <th>文件名</th>
                            <th width="150px">文件类型</th>
                            <th width="100px">操作</th>
                        </tr>
                        </thead>
                        <tbody v-if="fj.file !== undefined && fj.file !== null && fj.file.length>0">
                        <tr v-for="(data,index) in fj.file" :key="data.id">
                            <td><span class="num_box blue_bj" v-text="index+1">1</span></td>
                            <td class="box_l" v-text="data.name"></td>
                            <td v-text="data.type">挂牌文件</td>
                            <td><a href="javascript:void(0);" @click="downloadFile(data.url, data.name)">下载</a></td>
                        </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                            <td colspan="10" style="color: #999;display: none">暂无记录</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <!--end内容-->
            </div>
        </div>
        <!--end下载本次挂牌文件-->
        <!--end_弹框 -->
    </div>
</template>

<script>
    import {api} from '@/core/api'
    import {getQueryVariable, findKey, downloadFile} from '@/core/common'
    import Attachment from "@/components/Attachment";
    // import Jmxx from "@/components/Jmxx";
    import Search from "@/components/Search";
    import FileDownload from "@/components/FileDownload";
    import Jmxx from "@/components/Jmxx";
    import Jmxx2 from "@/components/Jmxx2";

    export default {
        name: "Detail",
        components: {Search, Attachment, Jmxx, Jmxx2},
        data() {
            return {
                selectedNav: null,
                nav: {
                    "正在公告": "01",
                    "竞价过程": "02",
                    "结果公示": "03",
                    "所有挂牌": "04",
                    "全文搜索": "05",
                    "正在资审": "06",
                    "竞价结果": "07",
                },
                selectedNavEn: null,
                navEn: {
                    "zzgg": "01",
                    "zzgp": "02",
                    "jggs": "03",
                    "sygp": "04",
                    "qwss": "05",
                    "zzzs": "06",
                    "jjjg": "07",
                },
                selectedTab: '详细信息',
                detail: {},
                cr_title: "",
                fj: {
                    pic: [],
                    video: [],
                    file: []
                },
                params: {
                    category: "Gtzy",
                    id: null
                },
                cjgsbt: "",
                xzbt: "",
                jggsId: "",
                jggsFjDomain: "",
                jggsFjList: [],
                jjsType: '2'
            }
        },
        mounted() {
            this.jjsType = getQueryVariable("jjsType") ? getQueryVariable("jjsType") : '2';
            this.params.id = getQueryVariable("id");

            const nav = getQueryVariable("nav");
            this.selectedNav = findKey(this.nav, nav);
            this.selectedNavEn = findKey(this.navEn, nav);

            api.getDetailById(this.params).then(response => {
                this.detail = response.data;
                this.cr_title = this.detail.crnr;
                const toJmxx = getQueryVariable("toJmxx");
                if (toJmxx) {
                    document.getElementById("JMXX").click();
                }
            });
            api.getPic({id: this.params.id}).then(response => {
                this.fj.pic = response.data;
            });
            api.getFile({id: this.params.id}).then(response => {
                let file = [];
                let responseData = response.data;
                responseData.forEach(item => {
                    let data = {
                        id: item.id,
                        url: this.$URL.FILE + item.storedFilePath,
                        name: item.uploadedFileName,
                        type: '挂牌文件'
                    };
                    file.push(data)
                });
                this.fj.file.push(...file);
            });
            api.getBdfj({id: this.params.id}).then(response => {
                let file = [];
                let responseData = response.data;
                responseData.forEach(item => {
                    let data = {
                        id: item.id,
                        url: this.$URL.FILE + item.storedFilePath,
                        name: item.uploadedFileName,
                        type: '标的附件'
                    };
                    file.push(data)
                });
                this.fj.file.push(...file);
            });
        },
        methods: {
            downloadFile
        },
        computed: {
            isShowJmxx() {
                return this.selectedTab === '竞买信息' && this.detail.jyID;
            },
            showJmxx() {
                return this.selectedNav === '竞价过程' || this.selectedNav === '竞价结果';
            },
            showJggs() {
                return this.selectedNav === '结果公示';
            }
        }
    }
</script>

<style scoped>
    .item_a:hover {
        color: #fff;
        background-color: #4293f4;
    }
</style>
<style>

    .detail_content {
        overflow: auto;
    }

    .detail_content table {
        margin: 0 auto;
    }

    .detail_content table td {
        padding: 10px;
    }

    .detail_content table p {
        margin: 0 !important;
        text-indent: 0;
    }

    .detail_content img {
        max-width: 1000px;
    }

    .detail_content pre {
        white-space: pre-wrap; /* css3.0 */
        white-space: -moz-pre-wrap; /* Firefox */
        white-space: -pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .detail_content h2 {
        font: 24px/1.5 Arial, Lucida, Verdana, Helvetica, sans-serif;
        text-align: center;
        color: rgb(0, 112, 164);
        font-size-adjust: none;
        font-stretch: normal;
    }

    .detail_content p {
        line-height: 24px;
        font-size: 14px;
        margin-bottom: 10px;
    }

    .detail_content b {
        color: rgb(51, 51, 51);
        font-size: 16px;
        font-weight: bold;
    }

    .detail_content li {
        color: rgb(255, 102, 0);
        line-height: 24px;
        font-size: 14px;
    }

    .detail_content a {
        text-decoration: none;
    }

    .detail_content li a {
        text-decoration: none;
    }

    .detail_content li a:hover {
        color: rgb(255, 102, 0);
    }

    .cont_close {
        padding: 10px 20px;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }
</style>
